export const DefaultCostCenterId = '0000000-0000-0000-0000-000000000000';
